import { RootState } from '../store';

export const getClassicDuel = (state: RootState) => state.settings.classicDuel;
export const getTeamDuel = (state: RootState) => state.settings.teamDuel;
export const getQuickDuel = (state: RootState) => state.settings.quickDuel;
export const getDuel = (state: RootState) => state.settings.duelSettings;
